import { useEffect } from "react";
import { useSubMenu } from "../empreenderUI/SubMenuContext";

// O estado aberto/fechado do menu lateral mora dentro do empreender-ui (useSubMenu), fora do
// alcance do App.tsx. Este componente fica dentro do ContentApp e fecha o menu quando o App pede,
// por evento — só no celular/tablet, onde o menu cobre o conteúdo.
const EVENTO = "central:fechar-menu";
const LARGURA_CELULAR = 768; // mesmo limite do VerificaSeUsuarioEstaNoMobile (menu começa fechado)

export const pedirFecharMenuNoCelular = () => window.dispatchEvent(new Event(EVENTO));

const FecharMenuNoCelular = () => {
  const { setSideBarOpen } = useSubMenu();

  useEffect(() => {
    const fechar = () => {
      if (window.innerWidth <= LARGURA_CELULAR) setSideBarOpen?.(false);
    };
    window.addEventListener(EVENTO, fechar);
    return () => window.removeEventListener(EVENTO, fechar);
  }, [setSideBarOpen]);

  return null;
};

export default FecharMenuNoCelular;
